import React from 'react'
import Layout from '../../Layout/Layout'
import deep1 from '../../images/deep1.PNG'

import deep2 from '../../images/deep2.PNG'

import { Link } from "react-router-dom";

const DeepTech_Summit = () => {
  return (
    <Layout>
        <div className='uk-container'>
            <div><h2 className='light uk-text-bold uk-margin-xlarge-top'>DeepTech Summit</h2></div>



            <div className='uk-grid'>
               <div className='uk-width-1-2@s'>
                      <p className='light'>The DeepTech Summit (DTS) 2025 in Morocco, Africa’s largest
                         deeptech convening hosted by UM6P, saw Moolu Venture Lab play a prominent role
                          in continental discussions on AI and deep technology innovation. The 
                          participation aimed to position the Lab as a leading voice and to actively
                           contribute to shaping the future of deeptech across Africa. This strategic
                            presence underscored the importance of African-led narratives in global 
                            deeptech dialogues, ensuring that local perspectives and challenges were
                             brought to the forefront.
</p>

                <p className='light'>A key highlight was the feature of Prince Ogbonna, Moolu Venture
                     Lab's CEO, on the influential “Real Talks” track, where he delivered critical 
                     insights. His discussions focused on the complex challenges of AI adoption in Africa,
                      the continent’s strategic innovation positioning in a globally competitive landscape,
                       and the influence of global geopolitics on technology transfer and deeptech investment.
                        This level of engagement solidified the Lab's expertise in the technical, ethical,
                         and policy aspects of emerging technologies.</p>
               </div>

                <div className='uk-width-1-2@s'>
                    <img src={deep1} />
          </div>
            </div>


              <div className='uk-grid'>
               <div className='uk-width-1-2@s'>
                    <img src={deep2} />  


                 </div>

                <div className='uk-width-1-2@s'>
                         <p className='light'>Moolu Venture Lab used the Summit to 
                            engage actively with a diverse group of stakeholders,
                             including leading ecosystem actors, investors, and 
                             policymakers from Africa, Europe, and the MENA 
                             (Middle East and North Africa) region. The 
                             participation successfully strengthened cross-continental
                              collaboration with organizations like UM6P Ventures. 
                              This engagement ultimately opened critical pathways for
                               future AI-centered collaborations and positioned Moolu Venture 
                               Lab as a leading advocate for ethical AI, research commercialization,
                                and innovation governance in Africa.
</p>

            
                    
          </div>
            </div>



        </div>
        </Layout>
  )
}

export default DeepTech_Summit